// @ts-nocheck

/**
 * オーナーの承認状況（pending:未承認 / approved:承認済み / rejected:却下）
 */
export type TenantApplicationUpdateStatusBodyApprovalStatus = typeof TenantApplicationUpdateStatusBodyApprovalStatus[keyof typeof TenantApplicationUpdateStatusBodyApprovalStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TenantApplicationUpdateStatusBodyApprovalStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
} as const;
